/**
 * @file   src\components\Onboarding\WantAdRenewConfirmationModal.js
 * @brief  This file is responsible for want ad renew confirmation modal from notification
 * @date   April, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React from "react";
import { useNavigate } from "react-router-dom";
import { createPortal } from "react-dom";

const WantAdRenewConfirmationModal = (props) => {
  const navigate = useNavigate();
  const [domReady, setDomReady] = React.useState(false);

  const divStyle = {
    display: props.show ? "flex" : "none",
  };

  React.useEffect(() => {
    setDomReady(true);
  }, []);

  const container = domReady ? document.querySelector(".notif-modal-container") : null;

  if (!domReady || !container) {
    return null;
  }

  return createPortal(
    <div className="modal-new" style={divStyle} onFocusOut={props.onHide}>
      <div className="modal-content-new">
        <h3>Are you sure you want to renew this Want ad?</h3>
        <button
          className="btn btn-primary w-100"
          onClick={() => {
            props.onConfirmReniewWantAd();
          }}
        >
          Confirm
        </button>

        <button
          variant=""
          onClick={props.onHide}
          className="btn btn-cancel w-100"
        >
          Cancel
        </button>
      </div>
    </div>,
    container
  );
};
export default WantAdRenewConfirmationModal;
